import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Hero from "./Hero";
import CalculatorScreen from "./CalculatorScreen";
import { trackPageView } from "./utils/analytics";
import "./App.css";

// Component to track page views on route changes
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, document.title);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <PageViewTracker />
      <div className="App">
        <Routes>
          {/* Hero Component - Landing page */}
          <Route path="/" element={<Hero />} />

          {/* CalculatorScreen Component */}
          <Route path="/calculator" element={<CalculatorScreen />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
